var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"back",attrs:{"type":"primary"},on:{"click":_vm.gobackClick}})}
var staticRenderFns = []

export { render, staticRenderFns }